import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://bece14a2ece40584e2f034a1f3e6724f@o4509433876381696.ingest.us.sentry.io/4509523767263232",
  sendDefaultPii: true,
});

// Suppress findDOMNode warnings in development
if (process.env.NODE_ENV === "development") {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("Warning: findDOMNode is deprecated")
    ) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
